module.exports = __webpack_public_path__ + "public/img/jl.d436f9f7.png";